import { Divider } from '@dixa/lib-shared-habla';

import { useCopilotTrial } from 'utils/useCopilotTrial';
import { useEditorContext } from 'utils/useEditorContext';

import styles from '../copilotPinnedActions.module.scss';

import { PinnedActionButton } from './pinnedActionButton';

export const Undo = (): JSX.Element | null => {
  const { undo, canUndo } = useEditorContext();
  const { hasCopilot } = useCopilotTrial();

  if (!hasCopilot || !canUndo()) {
    return null;
  }

  return (
    <>
      <Divider orientation="vertical" className={styles.undoDivider} />
      <PinnedActionButton icon="undo" label="Undo" onClick={undo} />
    </>
  );
};
